import { Col, Form } from "react-bootstrap";

function FilterExternalLetters({ state: { filter, setFilter } }) {
  return (
    <div className="d-flex flex-wrap">
      <Col xs={12} sm={6} md={4} xl={3}>
        <Form.Label>تعداد نمایش:</Form.Label>
        <Form.Select
          defaultValue={filter.numberitems}
          onChange={e =>
            setFilter(cur => ({
              ...cur,
              numberitems: parseInt(e.target.value),
              numberpage: 1,
            }))
          }
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </Form.Select>
      </Col>
    </div>
  );
}

export default FilterExternalLetters;
